<template>
    <div class="Order">
        <div class="page-title">草稿箱</div>
        <div class="page-desc">这里存放您尚未完成提交的作品</div>
        <div class="table-container">
            <el-table 
                :data="tableData" 
                border
                class="no-wrap-table"
                :show-overflow-tooltip="false">
                <el-table-column type="selection" align="center" width="55" />
                <el-table-column cell-class-name="custom-text-size" prop="projectCode" label="项目编号" min-width="120"></el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="projectCase" 
                    label="项目主题" 
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.projectCase }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="worksType" 
                    label="内容形式" 
                    min-width="120"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.worksType }}</div>
                    </template>
                </el-table-column>
                <el-table-column 
                    cell-class-name="custom-text-size ellipsis-cell" 
                    prop="worksName" 
                    label="作品名称" 
                    min-width="150"
                    show-overflow-tooltip>
                    <template slot-scope="scope">
                        <div class="ellipsis-content">{{ scope.row.worksName }}</div>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" prop="statusText" label="状态" min-width="100">
                    <template slot-scope="scope">
                        <el-tag :type="getStatusType(scope.row.status)">
                            {{ scope.row.statusText }}
                        </el-tag>
                    </template>
                </el-table-column>
                <el-table-column cell-class-name="custom-text-size" label="操作" fixed="right" width="150">
                    <template slot-scope="scope">
                        <div class="operation-buttons">
                            <el-button 
                                class="ColorBlue" 
                                size="mini" 
                                @click="handleEdit(scope.row)">
                                编辑
                            </el-button>
                            <el-button 
                                class="ColorGreen" 
                                size="mini" 
                                type="success"
                                @click="handleSubmit(scope.row)">
                                提交
                            </el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <div class="PageDis">
            <el-pagination 
                background 
                :page-sizes="[10, 20, 50]" 
                layout="prev,pager,next,total,sizes"  
                @size-change="SizeChange" 
                @current-change="PageChange" 
                :total="total" 
                :current-page="page" 
                :hide-on-single-page="false">
            </el-pagination>
        </div>
        <el-dialog title="作品详情" :visible.sync="dialogVisible" width="900px" :close-on-click-modal="false">
            <div class="detail-content">
                <div class="section-title">基本信息</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="label">姓名：</span>
                        <span class="value">{{viewForm.userName}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">所属项目：</span>
                        <span class="value">{{viewForm.projectCode}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">电话：</span>
                        <span class="value">{{viewForm.userPhone}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">邮箱：</span>
                        <span class="value">{{viewForm.userEmail}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">单位：</span>
                        <span class="value">{{viewForm.userUnitLevel}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">职位：</span>
                        <span class="value">{{viewForm.userZhicheng}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">科室：</span>
                        <span class="value">{{viewForm.userDept || ''}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">职称：</span>
                        <span class="value">{{viewForm.userZhicheng}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">单位等级：</span>
                        <span class="value">{{viewForm.userUnitLevel}}</span>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="section-title">专业信息</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <span class="label">项目编号：</span>
                        <span class="value">{{viewForm.projectCode}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">作品名称：</span>
                        <span class="value">{{viewForm.worksName}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">项目主题：</span>
                        <span class="value">{{viewForm.projectCase}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">创作时间：</span>
                        <span class="value">{{viewForm.workTime || ''}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">作品成绩：</span>
                        <span class="value">{{viewForm.isGood === 1 ? '优秀' : '一般'}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">内容形式：</span>
                        <span class="value">{{viewForm.worksType}}</span>
                    </div>
                    <div class="detail-item">
                        <span class="label">作品状态：</span>
                        <span class="value">{{viewForm.statusText}}</span>
                    </div>
                    
                    <!-- 根据内容形式显示相应的文件 -->
                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普文章') || viewForm.rawWorksType === '1')" class="detail-item">
                        <span class="label">科普文章：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/word.png" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普文章')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普文章')">下载</el-button>
                            </div>
                        </div>
                    </div>
                    
                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普图画') || viewForm.rawWorksType === '2')" class="detail-item">
                        <span class="label">科普图画：</span>
                        <div class="file-item">
                            <!-- <img src="../../assets/applyRey/mp4.jpg" class="file-icon" /> -->
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普图画')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普图画')">下载</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普短视频') || viewForm.rawWorksType === '3')" class="detail-item">
                        <span class="label">科普短视频：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普短视频')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普短视频')">下载</el-button>
                            </div>
                        </div>
                    </div>

                    <div v-if="viewForm.worksType && (viewForm.worksType.includes('科普讲座') || viewForm.rawWorksType === '4')" class="detail-item">
                        <span class="label">科普讲座：</span>
                        <div class="file-item">
                            <img src="../../assets/applyRey/mp4.jpg" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('科普讲座')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('科普讲座')">下载</el-button>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="section-divider"></div>
                
                <div class="section-title">作品授权书</div>
                <div class="detail-grid">
                    <div class="detail-item">
                        <div class="file-item">
                            <img src="../../assets/applyRey/pdf.png" class="file-icon" />
                            <div class="file-actions">
                                <el-button type="text" class="action-btn" @click="viewFile('授权书')">查看</el-button>
                                <el-button type="text" class="action-btn" @click="downloadFile('授权书')">下载</el-button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="dialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
    import { checkTokenExpiration, clearLoginInfo } from '@/utils/auth'

    export default {
        data() {
            return {
                i:1,
                tableData:[],
                total:0,
                page:1,
                SizePage:10,
                dialogVisible: false,
                viewForm: {
                    id: '',
                    userName: '',
                    userPhone: '',
                    userUnitLevel: '',
                    userZhicheng: '',
                    userEmail: '',
                    projectCode: '',
                    projectCase: '',
                    worksType: '',
                    worksName: '',
                    status: '',
                    statusText: ''
                }
            }
        },
        created() {
            this.getWorksList();
        },
        methods: {
            ToggleNav(i){
                this.i = i;
            },
            LockInfo(row){
                
            },
            SizeChange(val) {
                this.SizePage = val;
                this.page = 1;
                this.getWorksList();
            },
            PageChange(val) {
                this.page = val;
                this.getWorksList();
            },
            getWorksTypeText(types) {
                const typeMap = {
                    '1': '科普文章',
                    '2': '科普图画',
                    '3': '科普短视频',
                    '4': '科普讲座'
                };
                
                const typeArray = types.split(',');
                
                return typeArray.map(type => typeMap[type.trim()] || type).join('，');
            },
            getWorksList() {
                // 检查token是否有效
                const status = checkTokenExpiration();
                if (status.expired) {
                    clearLoginInfo(); // 清除登录信息
                    this.$confirm(status.message, '提示', {
                        confirmButtonText: '去登录',
                        cancelButtonText: '取消',
                        type: 'warning',
                        center: true,
                        showClose: false,
                        closeOnClickModal: false,
                        closeOnPressEscape: false
                    }).then(() => {
                        this.$router.push('/');
                    }).catch(() => {
                        this.$router.push('/');
                    });
                    return;
                }

                const params = {
                    pageNum: this.page,
                    pageSize: this.SizePage
                };
                
                this.$get('/api/v1/works/worksdraftlist', params).then(res => {
                    if (res.data.code === 200) {
                        this.tableData = res.data.rows.map(item => ({
                            id: item.id,
                            userName: item.userName,
                            userPhone: item.userPhone,
                            userUnitLevel: item.userUnitLevel,
                            userZhicheng: item.userZhicheng,
                            userEmail: item.userEmail,
                            projectCode: item.projectCode,
                            projectCase: item.projectCase,
                            worksType: this.getWorksTypeText(item.worksType),
                            worksName: item.worksName,
                            status: item.status,
                            statusText: this.getStatusText(item.status)
                        }));
                        this.total = res.data.total || 0;
                    } else {
                        this.$message.error(res.data.msg || '获取列表失败');
                    }
                }).catch(err => {
                    console.error('获取草稿箱列表失败:', err);
                    this.$message.error('获取列表失败');
                });
            },
            getStatusText(status) {
                const statusMap = {
                    0: '审核中',
                    1: '评分中',
                    2: '审核未通过',
                    3: '审核通过',
                    4: '已签署',
                    5: '已付款',
                };
                return statusMap[status] || status;
            },
            handleEdit(row) {
                // 先获取草稿详情
                this.$get(`/api/v1/works/workdraftinfo/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        // 获取草稿详情数据
                        const draftData = res.data.data;
                        console.log('获取到的草稿详情原始数据:', draftData);
                        
                        // 设置草稿标识和数据
                        localStorage.setItem('isDraft', 'true');
                        localStorage.setItem('draftData', JSON.stringify(draftData));
                        
                        // 跳转到 ApplyReg 路由
                        this.$router.push({
                            path: '/ApplyReg',
                            query: {
                                type: 1,
                                isDraft: 'true',
                                draftId: row.id
                            }
                        });
                    } else {
                        this.$message.error(res.data.msg || '获取草稿详情失败');
                    }
                }).catch(err => {
                    console.error('获取草稿详情失败:', err);
                    this.$message.error('获取草稿详情失败');
                });
            },
            handleSubmit(row) {
                this.$confirm('确认提交该草稿作品?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    // 调用提交草稿的接口
                    this.$post(`/api/v1/works/worksdraft/${row.id}`).then(res => {
                        if (res.data.code === 200) {
                            this.$message.success('提交成功');
                            this.getWorksList();
                        } else if (res.data.code === 500 && res.data.msg === '本月已提交5次作品') {
                            this.$message.warning('本月提交次数已达上限，请下个月再试');
                        } else {
                            this.$message.error(res.data.msg || '提交失败');
                        }
                    }).catch(err => {
                        console.error('提交草稿失败:', err);
                        this.$message.error('提交失败');
                    });
                }).catch(() => {
                    this.$message.info('已取消提交');
                });
            },
            handleView(row) {
                this.$get(`/api/v1/works/workinfo/${row.id}`).then(res => {
                    if (res.data.code === 200) {
                        // 获取完整的作品详情后显示
                        const detail = res.data.data;
                        // 保存原始的worksType值用于条件判断
                        const rawWorksType = detail.worksType;
                        // 转换worksType为文本描述
                        detail.worksType = this.getWorksTypeText(detail.worksType);
                        this.viewForm = {
                            ...row,
                            ...detail,
                            rawWorksType // 保存原始值
                        };
                        this.dialogVisible = true;
                    } else {
                        this.$message.error(res.data.msg || '获取作品详情失败');
                    }
                }).catch(err => {
                    console.error('获取作品详情失败:', err);
                    this.$message.error('获取作品详情失败');
                });
            },
            getStatusType(status) {
                const typeMap = {
                    '0': 'info',
                    '1': 'warning',
                    '2': 'danger',
                    '3': 'success',
                    '4': 'success',
                    '5': 'success'
                };
                return typeMap[status] || '';
            },
            viewFile(fileType) {
                let filePath = '';
                
                switch(fileType) {
                    case '科普文章':
                        filePath = this.viewForm.workFile;
                        break;
                    case '科普图画':
                        filePath = this.viewForm.workPicFile;
                        break;
                    case '科普短视频':
                        filePath = this.viewForm.workVedioFile;
                        break;
                    case '科普讲座':
                        filePath = this.viewForm.workJzFile;
                        break;
                    case '授权书':
                        filePath = this.viewForm.workAuthFile;
                        break;
                    default:
                        filePath = '';
                }
                
                if (filePath) {
                    window.open(filePath, '_blank');
                } else {
                    this.$message.info(`查看${fileType}文件`);
                }
            },
            downloadFile(fileType) {
                let filePath = '';
                
                switch(fileType) {
                    case '科普文章':
                        filePath = this.viewForm.workFile;
                        break;
                    case '科普图画':
                        filePath = this.viewForm.workPicFile;
                        break;
                    case '科普短视频':
                        filePath = this.viewForm.workVedioFile;
                        break;
                    case '科普讲座':
                        filePath = this.viewForm.workJzFile;
                        break;
                    case '授权书':
                        filePath = this.viewForm.workAuthFile;
                        break;
                    default:
                        filePath = '';
                }
                
                if (filePath) {
                    const link = document.createElement('a');
                    link.href = filePath;
                    link.download = filePath.split('/').pop();
                    document.body.appendChild(link);
                    link.click();
                    document.body.removeChild(link);
                } else {
                    this.$message.info(`下载${fileType}文件`);
                }
            }
        },
    }
</script>
<style scoped>
    .Order {
        width: 100%;
        min-width: 910px;
    }

    .page-title {
        font-size: 22px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 10px;
    }

    .page-desc {
        font-size: 14px;
        color: #909399;
        margin-bottom: 20px;
    }

    .table-container {
        width: 100%;
        overflow-x: auto;
        background: #fff;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
        padding-bottom: 8px;
    }

    .table-container::-webkit-scrollbar {
        height: 8px;
        background-color: #f5f5f5;
    }

    .table-container::-webkit-scrollbar-thumb {
        background: #909399;
        border-radius: 4px;
    }

    .table-container::-webkit-scrollbar-thumb:hover {
        background: #606266;
    }

    .table-container::-webkit-scrollbar-track {
        background: #e4e7ed;
        border-radius: 4px;
    }

    .no-wrap-table {
        width: max-content !important;
        min-width: 100%;
    }

    ::v-deep .el-table th {
        text-align: center;
        white-space: nowrap !important;
        color: #303030;
        font-weight: bold;
        background-color: #f5f5f5;
    }

    ::v-deep .el-table td {
        text-align: center;
        white-space: nowrap !important;
    }

    ::v-deep .el-table .cell {
        white-space: nowrap !important;
        line-height: 23px;
    }

    .custom-text-size {
        font-size: 14px !important;
        text-align: center;
    }

    .PageDis {
        display: flex;
        align-items: center;
        justify-content: center;
        padding: 20px;
        background: #fff;
        margin-top: 20px;
        border-radius: 4px;
        box-shadow: 0 2px 12px 0 rgba(0,0,0,.1);
    }

    .operation-buttons {
        display: flex;
        align-items: center;
        justify-content: center;
        white-space: nowrap;
        flex-wrap: wrap;
        gap: 5px;
    }

    .operation-buttons .el-button {
        margin-right: 0;
        margin-left: 0;
    }

    .ColorBlue {
        color: #0385EB;
        border-color: #0385EB;
    }
    
    .ColorBlue:hover {
        color: #fff;
        background-color: #0385EB;
        border-color: #0385EB;
    }

    .ColorRed {
        color: #f56c6c;
        border-color: #f56c6c;
    }

    .ColorRed:hover {
        color: #fff;
        background-color: #f56c6c;
        border-color: #f56c6c;
    }
    
    .ColorGreen {
        color: #ffffff;
        border-color: #ffffff;
    }
    
    .ColorGreen:hover {
        color: #fff;
        background-color: #67c23a;
        border-color: #67c23a;
    }

    ::v-deep .ellipsis-cell {
        max-width: 150px;
    }

    ::v-deep .ellipsis-cell .cell {
        width: 100%;
        padding: 0 8px;
    }

    .ellipsis-content {
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        width: 100%;
    }

    ::v-deep .el-tooltip__popper {
        max-width: 50%;
        line-height: 1.5;
        padding: 8px 12px;
        font-size: 14px;
    }

    ::v-deep .el-table td:not(.ellipsis-cell) .cell {
        white-space: nowrap !important;
        overflow: visible !important;
        text-overflow: unset !important;
    }

    .detail-content {
        padding: 20px;
    }

    .section-title {
        font-size: 16px;
        font-weight: 600;
        color: #303133;
        border-left: 4px solid #409EFF;
        padding-left: 10px;
        margin-bottom: 20px;
    }

    .section-divider {
        height: 1px;
        background-color: #EBEEF5;
        margin: 20px 0;
    }

    .detail-grid {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
        gap: 20px;
        margin-bottom: 20px;
    }

    .detail-item {
        display: flex;
        align-items: flex-start;
    }

    .detail-item .label {
        width: 100px;
        color: #606266;
        font-weight: bold;
    }

    .detail-item .value {
        flex: 1;
        color: #333;
    }

    .file-item {
        display: flex;
        align-items: center;
    }

    .file-icon {
        width: 32px;
        height: 32px;
        margin-right: 10px;
    }

    .file-actions {
        display: flex;
        gap: 15px;
    }

    .action-btn {
        color: #409EFF;
        font-size: 14px;
    }

    .action-btn:hover {
        color: #66b1ff;
    }
</style>